import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { SectionCountersData } from '@fcp/lib-ui';
import { CountersContainerService } from './counters-container.service';

@Component({
  selector: 'fcp-counters-container',
  template: `
    <fcp-section-counters
      [sectionCounters]="data | async"
      (wasButtonClicked)="wasButtonClicked.emit($event)"
    >
    </fcp-section-counters>
  `
})
export class CountersContainerComponent implements OnInit {
  @Input() public id: string;
  @Output() public wasButtonClicked: EventEmitter<any> = new EventEmitter();
  public data: Observable<SectionCountersData>;

  constructor(private countersContainerService: CountersContainerService) {}

  ngOnInit() {
    this.data = this.countersContainerService.getContadores(this.id);
  }
}
